import axiosInstance from "../utils/axiosConfig";

// To fetch ALL categories (admin)
export const categoryService = {
  // For shop
  getActiveCategories: async () => {
    try {
      const response = await axiosInstance.get("/categories/active");
      return response.data.categories || [];
    } catch (error) {
      console.error("Error fetching ACTIVE categories:", error?.message, error?.response);
      return [];
    }
  }
};

export default categoryService;
